module.exports = __webpack_public_path__ + "img/ivTest_sub57.342bf208.jpg";